import { render, staticRenderFns } from "./blog-call-privacy.vue?vue&type=template&id=5ca652f5&scoped=true"
import script from "./blog-call-privacy.vue?vue&type=script&lang=js"
export * from "./blog-call-privacy.vue?vue&type=script&lang=js"
import style0 from "./blog-call-privacy.vue?vue&type=style&index=0&id=5ca652f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca652f5",
  null
  
)

export default component.exports